import { CombinedMode } from '@/components/CombinedMode';
import { SplitMode } from '@/components/SplitMode';
import { CombinedView } from './views/combined';
import { LenderView } from './views/lender';

const LoansAllPage = () => {
  return (
    <>
      <CombinedMode>
        <CombinedView />
      </CombinedMode>
      <SplitMode lender={<LenderView />} borrower={<CombinedView />} />
    </>
  );
};

export default LoansAllPage;